import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Combos/getComboObservacionesEyaculadoEliminado`, method: 'GET', body: null})
}
